

import React, { useEffect, useState, useRef } from "react";
import { ENDPOINTS } from "utils/Constants";
import axios from "axios";
import { currentUser } from "utils/CurrentUser";
// Chakra imports
import {
  Box,
  Button,
  Flex,
  Grid,
  Link,
  Text,
  useColorModeValue,
  SimpleGrid,
  Input
} from "@chakra-ui/react";

// Custom components
import Banner from "views/admin/exploreSkills/components/Banner";
import TableTopSkillLearners from "./components/TableTopSkillLearners";
import HistoryItem from "views/admin/marketplace/components/HistoryItem";
import Card from "components/card/Card.js";

import Skill from "./components/card/Skill";
import { notify } from "components/ToastNotification";
import { USER_LEVELS } from "utils/Constants";


export default function ExporeSkills() {
  // Chakra Color Mode
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const [topLearners, setTopLearners] = useState([]);
  const [topLearnedSkills, setTopLearnedSkills] = useState([]);

  const textColorBrand = useColorModeValue("brand.500", "white");
  const [skills, setSkills] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  const debounceTimer = useRef(null);

  const fetchSkills = async (query = '') => {
    try {
      const response = await axios.get(`${ENDPOINTS.GET_ALL_SKILLS}` + (query ? `?search=${query}` : ''), {
        headers: {
          Authorization: `Bearer ${currentUser.token}`,
        },
      });
      const responseData = response.data;
      if (!responseData.success) return notify(responseData.output);
      setSkills(responseData.data);
    } catch (error) {
      notify("Could not fetch skills.", "error");
    }
  };

  useEffect(() => {

    const fetchTopLearners = async () => {
      try {
        const response = await axios.get(ENDPOINTS.GET_TOP_SKILL_LEARNERS, {
          headers: {
            Authorization: `Bearer ${currentUser.token}`,
          },
        });
        const responseData = response.data;
        if (!responseData.success) return notify(responseData.output);
        setTopLearners(responseData.data);
      } catch (error) {
        notify("Could not fetch top leaders.", "error");
      }
    };

    const fetchMostLearndSkills = async () => {
      try {
        const response = await axios.get(ENDPOINTS.GET_MOST_LEARNED_SKILLS, {
          headers: {
            Authorization: `Bearer ${currentUser.token}`,
          },
        });
        const responseData = response.data;
        if (!responseData.success) return notify(responseData.output);
        setTopLearnedSkills(responseData.data);
      } catch (error) {
        notify("Could not fetch most learned skills.", "error");
      }
    }
    fetchTopLearners();
    fetchSkills();
    fetchMostLearndSkills();
  }, [currentUser.token])

  const handleSearchChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);

    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }

    debounceTimer.current = setTimeout(() => {
      fetchSkills(query);
    }, 300);
  };

  return (
    <Box pt={{ base: "180px", md: "80px", xl: "80px" }}>
      {/* Main Fields */}
      <Grid
        mb='20px'
        gridTemplateColumns={{ xl: "repeat(3, 1fr)", "2xl": "1fr 0.46fr" }}
        gap={{ base: "20px", xl: "20px" }}
        display={{ base: "block", xl: "grid" }}>
        <Flex
          flexDirection='column'
          gridArea={{ xl: "1 / 1 / 2 / 3", "2xl": "1 / 1 / 2 / 2" }}>
          <Banner />

          <Flex direction='column'>
            <Flex mb="20px">
              <Input
                placeholder="Search skills..."
                value={searchQuery}
                onChange={handleSearchChange}
                width={{ base: "100%", md: "50%" }}
                marginTop={'5%'}
                bg={useColorModeValue("white", "gray.700")}
                color={useColorModeValue("black","white")}
              />
            </Flex>
            <Flex
              mt='45px'
              mb='20px'
              justifyContent='space-between'
              direction={{ base: "column", md: "row" }}
              align={{ base: "start", md: "center" }}>
              <Text color={textColor} fontSize='2xl' ms='24px' fontWeight='700'>
                Trending Skills
              </Text>
            </Flex>
            <SimpleGrid columns={{ base: 1, md: 3 }} gap='20px'>
              {skills.map((skill) => (
                <Skill
                  key={skill.id}
                  name={skill.name}
                  image={skill.thumbnail}
                  learnItLink={`/admin/chat/${skill.id}`}
                  skillID={skill.id}
                  userStartedThisAlready={skill.userStartedThisAlready}
                  userLevels={USER_LEVELS}
                  currentLearningLevels={skill.currentLevels}
                  completedAllLevels={skill.completedAllLevels}
                />
              ))}
            </SimpleGrid>
            {/* <Text
              mt='45px'
              mb='36px'
              color={textColor}
              fontSize='2xl'
              ms='24px'
              fontWeight='700'>
              Recently Added
            </Text>
            <SimpleGrid
              columns={{ base: 1, md: 3 }}
              gap='20px'
              mb={{ base: "20px", xl: "0px" }}>

            </SimpleGrid> */}
          </Flex>
        </Flex>
        <Flex
          flexDirection='column'
          gridArea={{ xl: "1 / 3 / 2 / 4", "2xl": "1 / 2 / 2 / 3" }}>
          <Card px='0px' mb='20px'>
            {topLearners.length > 0
              ? (
                <TableTopSkillLearners
                  tableData={topLearners}
                />
              ) : ''}
          </Card>
          <Card p='0px'>
            <Flex
              align={{ sm: "flex-start", lg: "center" }}
              justify='space-between'
              w='100%'
              px='22px'
              py='18px'>
              <Text color={textColor} fontSize='xl' fontWeight='600'>
                Top learned skills
              </Text>
            </Flex>
            {topLearnedSkills.map(skill => (
              <HistoryItem
                name={skill.name}
                learnedCount={skill.learnedCount}
              />
            ))}


          </Card>
        </Flex>
      </Grid>
      {/* Delete Product */}
    </Box>
  );
}
